export const PortfolioStudioSettingTabEnum = {
	MarketViewSetting: "MarketViewSetting",
	ExplainabilitySettings: "ExplainabilitySettings",
	ReportCustomisation: "ReportCustomisation",
} as const;

export type PortfolioStudioSettingTabEnum =
	(typeof PortfolioStudioSettingTabEnum)[keyof typeof PortfolioStudioSettingTabEnum];
